import { FC } from "react";
import { PlayersList } from "./PlayersList"
import { SectionTitle } from "./SectionTitle"
import { PlayerInfo } from "../../types/fixtures/match";

interface SubstitutionsProps {
    homePlayers: PlayerInfo[];
    awayPlayers: PlayerInfo[];
}

export const Substitutions: FC<SubstitutionsProps> = ({
    homePlayers,
    awayPlayers
}) => {
    if (!homePlayers?.length && !awayPlayers?.length) {
        return null;
    }

    return (
        <div>
            <SectionTitle>
                Запасные
            </SectionTitle>
            <div className="flex flex-row justify-center gap-4">
                <PlayersList players={homePlayers} align="right"/>
                <PlayersList players={awayPlayers}/>
            </div>
        </div>
    )
}
